import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl';
import { useQueryRequest } from '../core/QueryRequestProvider'
import { getAll, getOneByIdbylang } from '../../../../services/common_requests'
import { useListView } from '../core/ListViewProvider'
import { ImageDimensionHint } from '../../../../../_dashboard/partials/components/ImageDimensionHint'

interface ImageEditModalProps {
    isOpen: boolean;
    onClose: () => void;
    selectedImage: { id?:string ,url: string; seoUrl?: string };
    selectedSlider: any;
    selectedSliderItemId: any;
    onSave: (updatedImage: { url: string; seoUrl?: string; link?: string; translations?: any[] }) => void;
}

const ImageEditModal: React.FC<ImageEditModalProps> = ({ isOpen, onClose, selectedImage, selectedSlider, selectedSliderItemId, onSave }) => {
    const [seoUrl, setSeoUrl] = useState(selectedImage.seoUrl || '');
    const [newImage, setNewImage] = useState<File | null>(null);
    const [previewImage, setPreviewImage] = useState(selectedImage.url);
    const [link, setLink] = useState(selectedSlider.link);
    const [translations, setTranslations] = useState(selectedSlider.translations|| [{
      language: 'en',
      text: '',
      description: '',
      buttonText: '',
    }]);
    const { state } = useQueryRequest();
    const [query, setQuery] = useState<any>(state);
    const { itemIdForUpdate, setItemIdForUpdate } = useListView()
    const [sliderItemId, setSliderItemId] = useState(selectedSlider._id || '');
    
    const intl = useIntl()
    useEffect(() => {
        setSeoUrl(selectedImage.seoUrl || '');
        setPreviewImage(selectedImage.url);
    }, [selectedImage]);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setNewImage(file);
            setPreviewImage(URL.createObjectURL(file));
        }
    };
    const LANGUAGE_NAMES: { [key: string]: string } = {
        en: intl.formatMessage({ id: 'COMMON.ENGLISH_LANGUAGE' }),
        fr: intl.formatMessage({ id: 'COMMON.FRENSH_LANGUAGE' }),
        es: intl.formatMessage({ id: 'COMMON.ESPANGOL_LANGUAGE' }),
        ar: intl.formatMessage({ id: 'COMMON.ARABIC_LANGUAGE' }),
      };
    
    const [languages, setLanguages] = useState<{ code: string; name: string }[]>([]);
    const [selectedLanguage, setSelectedLanguage] = useState('en');
    useEffect(() => {
        if (languages.length > 0) {
          setSelectedLanguage(languages[0].code);
        }
      }, [languages]);
      useEffect(() => {
        getAll(query, '/languages').then((data) => {
          if (data && Array.isArray(data)) {
  
            const formattedLanguages = data.map((code: string) => ({
              code,
              name: LANGUAGE_NAMES[code] || code.toUpperCase(),
            }));
            setLanguages(formattedLanguages);
          }
        });
      }, [query]);

      useEffect(() => {
        if (selectedSliderItemId && selectedLanguage) {
          getOneByIdbylang(`/sliders/item/${selectedSliderItemId}?language=${selectedLanguage}`)
            .then((data) => {
                setSeoUrl(data.seoUrl || selectedImage.seoUrl);
                setLink(data.link || '');
                setTranslations(data.translations || [{
                  language: selectedLanguage,
                  text: '',
                  description: '',
                  buttonText: '',
                }]);
                setPreviewImage(data.url || selectedImage.url);
      
              if (data && data.translations) {

                // Mettre à jour toutes les traductions
              }
            })
            .catch((error) => console.error('Error fetching translation:', error));
        }
      }, [selectedLanguage, selectedSliderItemId]);

    const handleSave = () => {
        const updatedItem = {
            imageId: selectedImage.id, 

            url: newImage ? URL.createObjectURL(newImage) : selectedImage.url,
            seoUrl: seoUrl,
            link: link, 
            translations: translations,
          };
          const formData = new FormData();
          if (newImage) {
          }
          if (selectedImage.id) {
            formData.append('imageId', selectedImage.id);
            formData.append('seoUrl', seoUrl);
            if (newImage) formData.append('image', newImage);
          }

          formData.append('link', link);
          formData.append('translations[0][text]', translations[0]?.text);
          formData.append('translations[0][language]', translations[0]?.language);
          formData.append('translations[0][description]', translations[0]?.description);
          formData.append('translations[0][buttonText]', translations[0]?.buttonText);
  
        onSave(updatedItem);
    };

    if (!isOpen) return null;

    const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newLanguage = e.target.value;
        setSelectedLanguage(newLanguage);
      
      };
    return (
        <div className="modal modal-style">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{intl.formatMessage({
                            id: 'COMMON.UPDATE_IMAGE'
                        })}</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <img
                            src={previewImage.includes('/images/') ? process.env.REACT_APP_API_URL_IMAGE + previewImage : previewImage}
                            alt="Selected"
                            className='modal-body-image'
                           
                        />
                        <div className="form-group mb-3">
                            <label>{intl.formatMessage({
                                id: 'COMMON.UPLOAD_IMAGE',
                            })}</label>
                            <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={handleImageChange}
                            />
                            <ImageDimensionHint entity='sliderHero' />
                        </div>
                        {typeof selectedImage.url === 'string' && (
                            <div className="form-group">
                                <label>{intl.formatMessage({
                                    id: 'COMMON.ALT_IMAGE',
                                })} </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={seoUrl || ''}
                                    onChange={(e) => setSeoUrl(e.target.value)}
                                />
                            </div>
                        )}
                    <div className="form-group mb-3">
                    <label>{intl.formatMessage({ id: 'COLUMNS.LINK' })}</label>
                    <input
                        type="text"
                        className="form-control"
                        value={link || ''}
                        onChange={(e) => setLink(e.target.value)}
                    />
                    </div>
                                {/* Language Selector */}
                    <div className="form-group mb-3">
                    <label>{intl.formatMessage({ id: 'COLUMNS.LANGUAGE' })}</label>
                    <select
                        className="form-select"
                        value={selectedLanguage}
                        onChange={handleLanguageChange}
                    >
                        {languages.map((lang) => (
                        <option key={lang.code} value={lang.code}>
                            {lang.name}
                        </option>
                        ))}
                    </select>
                    </div>

                    <div key={'1'} className="form-group mb-3">
                        <label>{intl.formatMessage({ id: 'COLUMNS.TEXT' })} ({translations[0]?.language})</label>
                        <input
                        type="text"
                        className="form-control"
                        value={translations[0]?.text || ''}
                        onChange={(e) => {
                            const updatedTranslations = [...translations];
                            updatedTranslations[0].text = e.target.value;
                            setTranslations(updatedTranslations);
                        }}
                        />
                        <label>{intl.formatMessage({ id: 'COLUMNS.DESCRIPTION' })} ({translations[0]?.language})</label>
                        <input
                        type="text"
                        className="form-control"
                        value={translations[0]?.description || ''}
                        onChange={(e) => {
                            const updatedTranslations = [...translations];
                            updatedTranslations[0].description = e.target.value;
                            setTranslations(updatedTranslations);
                        }}
                        />
                        <label>{intl.formatMessage({ id: 'COLUMNS.BUTTON_TEXT' })} ({translations[0]?.language})</label>
                        <input
                        type="text"
                        className="form-control"
                        value={translations[0]?.buttonText || ''}
                        onChange={(e) => {
                            const updatedTranslations = [...translations];
                            updatedTranslations[0].buttonText = e.target.value;
                            setTranslations(updatedTranslations);
                        }}
                        />
                    </div>

</div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>{intl.formatMessage({
                            id: 'HEADER.RESET',
                        })}</button>
                        <button type="button" className="btn btn-primary" onClick={handleSave}>{intl.formatMessage({
                            id: 'HEADER.SAVE',
                        })}</button>
                    </div>
                  </div>

                </div>
            </div>
    );
};

export default ImageEditModal;